module.exports = "<h1 routerLink=\"/\">ImproAppar: Repliker</h1>\n"